import { Button, Modal } from "antd";
import * as ewcms from "../screen/EWCMS/styleMaster";

const defaultBtnStyle = ewcms.defaultBtnStyle;
const greyBtnStyle = ewcms.greyBtnStyle;

const ConfirmSubmitModal = (props: any) => {
  const { showModal, setshowModal, title, onConfirmSubmit } = props;
  const importantNotesUrl = `${window.location.origin}/ptps/importantNotesPage`;

  return (
    <Modal
      title={title}
      open={showModal}
      onOk={() => setshowModal(false)}
      onCancel={() => setshowModal(false)}
      footer={null}
    >
      <div style={{ textAlign: "left" }}>Are you sure to submit?</div>
      <div style={{ textAlign: "left", paddingBottom: 15 }}>
        By clicking “Submit”, it implies you have read & agreed with the terms
        and conditions including those governing conflict of interest as listed
        under{" "}
        <a href={importantNotesUrl} target="_blank" rel="noreferrer noopener">
          Important Notes
        </a>
      </div>

      <div className="cust-spacebetween" style={{ justifyContent: "flex-end" }}>
        <Button
          className={greyBtnStyle + " cust-button-height"}
          style={{ marginRight: "10px" }}
          onClick={() => setshowModal(false)}
        >
          Close
        </Button>
        <Button
          className={defaultBtnStyle + " cust-button-height"}
          onClick={onConfirmSubmit}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmSubmitModal;
